import { Link } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";
import { faqs } from "@/mocks/faqs";
import Breadcrumb from "@/components/feature/Breadcrumb";
import FaqAccordion from "@/components/feature/FaqAccordion";

const SITE = "https://zozxnbl.cn";
const groups = ["使用指引", "内容说明"] as const;

export default function Changjianwenti() {
  useSeo({
    title: "常见问题 | 51爆料网使用帮助与内容说明",
    description:
      "51爆料网常见问题汇总：栏目导航怎么用、内容多久更新、深度调查与实时热点的区别、发现内容偏差如何反馈等，帮助你更快上手本站。",
    keywords: "51爆料网常见问题,使用帮助,栏目导航用法,内容说明,反馈方式",
    canonical: "/changjianwenti",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({
          "@type": "Question",
          name: f.question,
          acceptedAnswer: { "@type": "Answer", text: f.answer },
        })),
      },
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "首页", item: SITE },
          { "@type": "ListItem", position: 2, name: "常见问题", item: `${SITE}/changjianwenti` },
        ],
      },
    ],
  });

  return (
    <>
      <section className="border-b border-background-200 bg-background-100">
        <div className="mx-auto max-w-[1280px] px-6 py-8 md:py-10">
          <Breadcrumb items={[{ label: "常见问题" }]} />
          <h1 className="mt-5 font-heading text-3xl font-black text-foreground-950 md:text-4xl">常见问题</h1>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-foreground-600">
            这里整理了读者在使用 51爆料网时最常问到的几个问题，按「使用指引」与「内容说明」两类排列。
            如果没有找到答案，可以通过邮箱与我们联系。
          </p>
        </div>
      </section>

      <div className="mx-auto max-w-[1280px] px-6 py-10">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-8">
            {groups.map((group) => {
              const items = faqs.filter((f) => f.group === group);
              if (items.length === 0) return null;
              return (
                <section key={group} className="mb-10">
                  <div className="mb-4 flex items-center gap-3">
                    <h2 className="font-heading text-xl font-bold text-foreground-950">{group}</h2>
                    <span className="h-px flex-1 bg-background-200" />
                    <span className="text-xs text-foreground-500">{items.length} 条</span>
                  </div>
                  <FaqAccordion items={items} />
                </section>
              );
            })}
          </div>

          <aside className="lg:col-span-4">
            <div className="rounded-lg border border-primary-200 bg-primary-50 p-6">
              <i className="ri-question-answer-line text-2xl text-primary-600" />
              <h2 className="mt-3 font-heading text-lg font-bold text-primary-950">还有其他疑问？</h2>
              <p className="mt-2 text-sm leading-relaxed text-primary-900">
                把你的问题发送至 hello@51baoliao.com，或直接到「关于我们」页面查看内容原则与联系方式。
              </p>
              <Link
                to="/guanyu"
                className="mt-4 flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                前往关于我们
                <i className="ri-arrow-right-line" />
              </Link>
            </div>

            <div className="mt-6 rounded-lg border border-background-200 bg-background-50 p-6">
              <h2 className="font-heading text-base font-bold text-foreground-950">快速入口</h2>
              <ul className="mt-3 space-y-2">
                <li>
                  <Link to="/lanmu" className="flex items-center gap-2 text-sm text-foreground-700 transition-colors hover:text-primary-600">
                    <i className="ri-compass-3-line text-primary-500" />
                    栏目导航（站点导览）
                  </Link>
                </li>
                <li>
                  <Link to="/pindao/shen-du-diao-cha" className="flex items-center gap-2 text-sm text-foreground-700 transition-colors hover:text-primary-600">
                    <i className="ri-search-eye-line text-primary-500" />
                    深度调查频道
                  </Link>
                </li>
                <li>
                  <Link to="/pindao/pi-yao-ke-pu" className="flex items-center gap-2 text-sm text-foreground-700 transition-colors hover:text-primary-600">
                    <i className="ri-shield-check-line text-primary-500" />
                    辟谣科普频道
                  </Link>
                </li>
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </>
  );
}